// i need a clinic visit page for Om City Complex Budigere, same template as the other clinic visit pages.
import React, { Component } from 'react';
import OmCityClinicsTiming from './OmCityComplexTiming';
import { Link } from 'react-router-dom';
import AssociatedPartners from './AssociatedPartners';
export default class ClinicVisitOmCityComplex extends Component {
  render() {
    return (
      <>
        <div className='Inner-banner'>
                <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/famphy-OmCityComplex-banner.jpg`} alt="Home Visits" />
              </div>
                <div className='clinic-visit'>
                    <OmCityClinicsTiming />
                    <div className='services-item container'>
                            <div className='row'>
                              <div className='col-lg-6 col-md-6 col-sm-12 v-align-middle mob-order-2 p-0'>
                                <div className='services-item-content'>
                                  <h2>Fam<span>Phy</span> Clinic</h2>          
                                  <h4>1 Floor, Om City Complex, Budigere, Bengaluru- 560049, Karnatka</h4>
                                  <Link to="/contacts" className="btn theam-btn-m">Contact Us</Link>
                                </div>
                              </div>
                              <div className='col-lg-6 col-md-6 col-sm-12 mob-order-1 p-0'>
                              <img className="img-fluid" src={`${process.env.PUBLIC_URL}/img/famphy-OmCityComplex-02.jpg`} alt="Home Visits" />
                              </div>
                            </div>
                          </div>
                      <AssociatedPartners />
                    
                </div>
      </>
    );
  }
}
// what is the arror need to be fixed in this cade?
